{
  "004a86e27232fce7": "No visits to verify.",
  "0493cb969d91ea9a": "Welcome to the Coverage Map",
  "04a42f7c16b521bc": "No open {{qualification}} cases to invite to. Create an open visit to invite workers from this area.",
  "092bc2a87238399a": "No-Call No-Show",
  "0bc7036b9c8f853f": "Error verifying visit",
  "0f7f493a341e0539": "Pay rate is required",
  "14f1ef21204a85f6": "Reading the map",
  "156aa4e6e7c6ad63": "{{count}} active workers",
  "15d1c540acc06613": "Professional pay",
  "163e44b102626149": "Evaluation",
  "18975c6a5e5e2e65": "Visit type",
  "19766ed6ccb2f4a3": "Cancel",
  "19c73a5cdf346d96": "Professional",
  "1a1d906ff06441d4": "Invite {{qualification}} workers",
  "1b8ca2977380b08c": "Selected area",
  "1c8ac867f052ea4a": "Visit",
  "1de694364549a005": "Discharge",
  "1fcbf4bdac901671": "{{count}} completed visit",
  "1fd9ae1607aa3d80": "Invite",
  "201faecafd7fcead": "active worker",
  "21a7351e10e648b7": "in view",
  "2430b497c904988b": "Already invited",
  "24ad7f23a5dbf398": "Your charge",
  "24b5201f7788af9a": "Charge rate cannot be negative",
  "24e1d93d66022fdc": "Nursing Evaluation",
  "25c547a91a6baf63": "Unknown professional",
  "269d7976cdbad0e3": "Missing requirements",
  "276683a048d4c29a": "Number of visits",
  "280321bbc8724bac": "Reject {{visitType}} visit",
  "293e087f99c84115": "Clinician type",
  "2bf936d3739dcbed": "{{count}} active {{qualification}} workers",
  "2c77e8bb09115161": "Resumption of Care",
  "2dc1717c0074bd4c": "Heatmap intensity scaling (admin)",
  "3074159c5075a11a": "We'll be in touch if we can find coverage there.",
  "307555f0e149852b": "Distance to patient",
  "3193ed520f35902d": "Confirm invite",
  "33c8e8de41c3a351": "Unverified",
  "3475b97eaa21ba68": "Verify visit",
  "36c20ac858034224": "Verify {{visitType}} visit",
  "3b629d1d6fd1ce07": "Max intensity cap",
  "3b7ea51793e9d906": "Clear search",
  "3cb0fb41a92993af": "Visit rejected",
  "3d6d01c471a5fafa": "Each cell is shaded by how many Clipboard workers were recently active in that area — workers who booked or worked visits there in the last 60 days, or who live nearby and recently used Clipboard. Hover any cell to see details. Click anywhere on the map to request future coverage.",
  "3d756ca324ccae30": "Failed to load visits. Please try again.",
  "3da728ac99008608": "Call us to get started — {{phone}}",
  "41e9cda2c8d88719": "Send an invite to {{workerName}} for this visit?",
  "42215cf334f6e189": "Failed to load workers for this area. Please try again.",
  "425553e9d708e4f4": "Couldn't load workers. Please try again.",
  "44e8a4b0697f79b5": "View visit details",
  "45771afd6b0c2b2a": "Each cell is shaded by how many Clipboard workers have booked or worked visits in that area or live nearby. Hover any cell to see details. Click anywhere on the map to request future coverage.",
  "461fad652d28d7cf": "Pay rate cannot be negative",
  "467193964f475270": "Recertification",
  "468ad2535f270ab1": "Possible duplicate detected. There is already another visit approved for this day.",
  "46931380ecf5947f": "Connect Clipboard Health directly to WellSky, Homecare Homebase, Axxess, and more — so visit records, worker profiles, and route sheet collection happen automatically.",
  "47fd6c9283968676": "View {{name}}'s profile",
  "4807303333989588": "Admission",
  "489ebe97d4e2f45f": "This visit has already been verified.",
  "4b63c8d6c82c9a2f": "Save rates",
  "4c1281cc747beda6": "This professional is locked and cannot receive new invites",
  "4dee407fa380008c": "Highlighted area shows previously fulfilled visits across Clipboard",
  "4e16b652d8ad5838": "{{count}} active {{qualification}} worker",
  "4f2273f736249aba": "Request received",
  "4f7838402f37674e": "Verified",
  "50d4275468f0c0d1": "Log scale",
  "554a75a70bcb181b": "Show coverage filters",
  "5ad3dbd1242a4cea": "Got it",
  "5c9efc015b6c7e8c": "Supervisory",
  "5f8702cbcca58f90": "This professional already works with this case",
  "5ff55e5f1680fcf8": "Professional pay: {{amount}}",
  "6007acbe30b2cd98": "Approve",
  "6239b93e96e9a8ee": "Notes (optional)",
  "63b17becd812dfd3": "Invited",
  "685360feff5b8d4b": "Connect your EMR and automate the busywork.",
  "6e7103f8c2ed7887": "Need coverage in this area?",
  "707fe149926f8925": "Pay rate must be less than $1000",
  "70b988869f2c2a82": "Request Future Coverage",
  "74a0d3884d034bfb": "Missing Notes",
  "7635fa0c85600c40": "Error rejecting visit",
  "764896efa69623da": "Couldn't load open cases. Please try again.",
  "76900f1bfd16c8d4": "Back",
  "76a13f805cdc1b8b": "Send invite",
  "7837f28c5c87bc30": "What the pay rates mean",
  "78dd445a55afa050": "Pin set",
  "798de6b2f0278566": "No workers have completed visits in this area for the selected visit.",
  "7a8708adfd9c68b3": "Pin: {{pinLabel}}",
  "7d9eb7acb13e2462": "Close",
  "7e1f964b72350f6e": "Failed to send invite. Please try again.",
  "835043ec8e6b7921": "Patient",
  "85d4fc7af49f6c7e": "The following workers have completed visits in this area",
  "8a2595eb866f0a93": "No visits to show.",
  "8b343cb31cf67510": "Search by patient",
  "913bde576062b8e5": "All visits",
  "917e144e4bc3da89": "Submit request",
  "93309e6195d47024": "{{amount}} /hr",
  "93a7facd599f7aa5": "Select a visit to see available workers.",
  "94b3dc97e7d05aaf": "Visit status",
  "9bebab3f16041c90": "None (auto-normalize)",
  "9c5b890662ab808e": "Reason: {{reason}}",
  "9dbd5037c08213b8": "Highlighted area shows Clipboard workers recently active in each area",
  "a00dd80c0367355e": "Visit date",
  "a193a1ede2a1e7ae": "Are you sure you want to verify this visit?",
  "a2b10196b0b9e407": "Charge rate must be less than $1000",
  "a30a2c3a1d70672c": "{{amount}} /visit",
  "a350af311c236a5c": "Avg. pay rate",
  "a405ecec9397a71c": "Error updating rates",
  "a536f4871f6f0754": "Edit rates",
  "a565fb28723f9f18": "The Coverage Map isn't enabled for your account yet.",
  "a630dd8f55675922": "Invite workers",
  "a67b04cd5c491d4d": "Worker",
  "a6b06da7806935f6": "This visit has already been verified and cannot be rejected.",
  "a78dbc1b8b4fba8a": "Visit details",
  "ab4fd936bc6d3cd0": "Click anywhere on the map to request coverage in that area.",
  "ab604a360777735f": "Reject",
  "aba684644f28ed36": "e.g., We are getting patients who need wound care",
  "ac56027a0ba70a7c": "Locating…",
  "ac8991ef01019cf5": "Load more",
  "ac9cde5b5bee03f3": "Coverage Map",
  "aea4a04a80426ed8": "Rejected",
  "b1041b973bc55b5e": "Visit verification",
  "b40a57c0c9b17557": "Invite sent",
  "b455784ab5307277": "Regular",
  "b944075326e4926e": "visits",
  "b9d487da5990f1de": "How the Coverage Map works",
  "ba3bbbe10d8bef66": "Loading…",
  "bc4f5feffd112d99": "Completed visits",
  "be201bd3525b6cbb": "The map shows org-wide, market-level coverage across Clipboard — not your personal account activity. Each cell is shaded by how many workers were recently active in that area.",
  "be974c6d5a7b0f82": "Map shading shows how many Clipboard workers have booked or worked visits in each area or live nearby",
  "c019fb04d862089c": "Loading coverage…",
  "c19c9d3c003257b5": "Link any EMR like WellSky, Homecare Homebase, Axxess, (and many more) to automate tasks like account creation, visit verification, route sheet collection, and QA.",
  "c2de3de5b2a9333c": "Cap value:",
  "c54580fe49a165c9": "Are you sure you want to reject this visit? Please tell us why:",
  "c897635c22a67087": "Visit Verification",
  "cab8c775bb84486c": "Pay rate",
  "cad7947500ea2aaf": "Charge rate",
  "cb6fb1213746e5f5": "Clear pin",
  "cceafec6b909cdc4": "Your request signals demand so we can plan future hiring in this area. It hasn't created a case or triggered an urgent fulfillment workflow.",
  "d075ae70f9a81c5c": "Verify only after confirming documentation meets your standards.",
  "d1b90358bb105a2c": "No recently active workers in this area yet. Click anywhere on the map to request coverage here.",
  "d46949d0ff447b1c": "The map shows org-wide, market-level coverage across Clipboard — not your personal account activity. Each cell is shaded by how many workers have booked or worked visits in that area or live nearby.",
  "d8402b10271eab51": "Edit {{visitType}} rates",
  "d8ef3d7510e714d1": "Charge rate is required",
  "dad8b127d02555df": "Your charge: {{amount}}",
  "daea89e163898dd1": "Notes Didn't Pass QA",
  "dc3838919b70dd24": "Duplicate Request",
  "e57499264f493e58": "Rejection reason",
  "e92eea890c7f4b8b": "Heatmap intensity cap",
  "e954de46c25f5126": "Admission & First",
  "ea68cfee139df482": "active workers",
  "eab0cd8fdf9bccec": "Hourly",
  "eb36aff7bf025843": "Whose data is this?",
  "ed8887d8ed8106fd": "{{count}} completed visits",
  "eea2745e2867a677": "Verify",
  "f0e68ac26df21840": "visit",
  "f124a41b43f90504": "Missing required documents",
  "f21be567be440aea": "Select a patient to continue.",
  "f2a7559ff9872a2b": "Reject visit",
  "f3531a486fe06c2c": "Visit approved",
  "f509fc0b514d654c": "Search a city or address",
  "f56bc1e7bc084f94": "Failed to load coverage map. Please try again.",
  "f81ab834de5f8491": "Reason",
  "f97e9da0e3b879f0": "Other",
  "fbdd2c9ace74f84d": "No completed visits in this area yet. Click anywhere on the map to request coverage here.",
  "fd1346d7693d29af": "{{count}} active worker"
}
